import React from 'react';
import PropTypes from 'prop-types';
import * as Api from 'api';
import { MapList } from '../';
import { Button, Collapse } from 'react-bootstrap';

class ImpactMapList extends React.Component {
  state = {
    maps : [],
    loading_maps: true,
    error: null,
    open : true,
  }
  static propTypes = {
    onViewMap: PropTypes.func,
  }
  constructor(props) {
    super(props);
    if(this.props.coords) {
      Api.fetchImpactingMaps({ lat: this.props.coords.lat, lng: this.props.coords.lng })
        .then(({maps, error}) => this.mounted ? this.setState({maps, loading_maps: false, error: null}) : null)
        .catch(error => this.mounted ? this.setState({error, loading_maps: false}) : null);
    }
    this.toggleShow = this.toggleShow.bind(this);
  }
  componentDidMount() {
    this.mounted = true;
  }
  toggleShow(e) {
    e.preventDefault();
    if(localStorage) {
      localStorage.setItem('impact-map-list.open', this.state.open ? 'false' : 'true');
      this.setState({ open: !this.state.open });
    }
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    if(typeof this.props.coords !== 'object' || !this.props.coords.lat || !this.props.coords.lng) {
      return <div></div>
    }
    const show_button = <a
      href='#'
      className="animated bounceIn wobble pull-right"
      onClick={this.toggleShow}
      >
      {this.state.open? 'Hide' : 'Show'}
    </a>;
    return(
      <div>
        {this.state.open ? show_button : null}
        <h5><i className="fa fa-map"></i> Maps</h5>
        <p>{this.props.details || 'List of maps impacting this place:'} {!this.state.open ? show_button : null}</p>
        <Collapse in={this.state.open}>
          <div>
            {this.state.error? (
              <div className="alert alert-danger">{this.state.error.message}</div>
            ) : ''}
            {this.state.loading_maps ? (
              <div><i className="fa fa-spin fa-spinner fa-2x"></i> Loading Maps</div>
            ) : <MapList onViewMap={this.props.onViewMap} maps={this.state.maps} />}
          </div>
        </Collapse>
      </div>
    )
  }
}

export default ImpactMapList;



// WEBPACK FOOTER //
// ./src/browser/components/maps/impact-map-list.js